import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import * as packageListingActions from '../actions';
import { PackageListingService } from '../../package-listing.service';
@Injectable()
export class PackageListingEffects {
  private actions$ = inject(Actions);
  private packageListingService = inject(PackageListingService);
  constructor() {}
  getAllPackageListings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(packageListingActions.getAllPackageListings),
      switchMap((action) =>
        this.packageListingService
          .getAllPackageListings(action.queryParams)
          .pipe(
            map((response) =>
              packageListingActions.getAllPackageListingsSuccess({
                data: response?.data?.results,
                pricingInfo: response?.pricingInfo,
                totalCount: response?.totalCount,
              })
            ),
            catchError((error: any) =>
              of(packageListingActions.getAllPackageListingsFailure(error))
            )
          )
      )
    )
  );
}